<div class="fondo flex-column" *ngIf="show">
    <div class="p-fluid">
        <img src="assets/img/logoSimescco.jpg" alt="" class="logo">
    </div>
    <div class="loading p-fluid">
        <p>c</p>
        <p>a</p>
        <p>r</p>
        <p>g</p>
        <p>a</p>
        <p>n</p>
        <p>d</p>
        <p>o</p>
    </div>
</div>